export default "__VITE_ASSET__CSjasvWz__"